import React from 'react'

const Textarea = ({field, validate, rows, maxLength}) => {
  let hasErrors = field.errors.length > 0 ? true : false

  if (!rows) {
    rows = 3;
  }

  return (
    <div className={hasErrors ? 'form-group text-danger' : 'form-group'}>
      <label className="form-control-label">{field.rules.title}</label>
      <textarea
        className={hasErrors ? 'form-control is-invalid' : 'form-control'}
        name={field.name}
        onBlur={e => validate(e.target.value, field)}
        value={field.value === null ? '' : field.value}
        onChange={e => validate(e.target.value, field)}
        rows={rows}
        disabled={field.disabled}
        maxLength={maxLength? maxLength:'' }
      />
      {field.errors.map((error, i) => (
        <div key={i} className="form-text text-danger">
          {error}
        </div>
      ))}
    </div>
  )
}


export default (Textarea)
